import React from 'react'

const SvgComponent = ({ svgRef, ...props }) => (
  <svg viewBox="0 0 573.492 144.985" ref={svgRef} {...props}>
    <title>
      Illustration of hand holding a heart, a computer with heart, and certificate
    </title>
    <defs>
      <style>
        {`.cls-1{fill:#d9d9d6}.cls-2{fill:#0090da}.cls-3{fill:#0061a0}.cls-4{fill:#f2f2f2}.cls-5{fill:#a7a8aa}.cls-6{fill:#218ece}.cls-8{fill:none;stroke:#ffc70a;stroke-miterlimit:10;stroke-width:1.5px}`}
      </style>
    </defs>
    <g
      id="Group_1586"
      data-name="Group 1586"
      transform="translate(-418.488 -170)"
    >
      <g id="Group_1584" data-name="Group 1584">
        <g id="blue-hand-1" transform="translate(418.488 257.714)">
          <g id="Group_651" data-name="Group 651">
            <g id="blue-hand" data-name="Group 650">
              <path
                id="Path_203"
                data-name="Path 203"
                className="cls-1"
                d="M123.568 64.273L108.95 78.447H70.708a2.724 2.724 0 0 1-1.772-.738 2.442 2.442 0 0 1 1.772-4.134h15.8a7.505 7.505 0 0 0 7.53-5.611A7.215 7.215 0 0 0 86.8 59.4H58.3a20.181 20.181 0 0 0-13.879 5.611l-9.007 8.712-4.873 4.725L17.7 91.293l39.128 18.752 10.04-9.893a9.826 9.826 0 0 1 6.94-2.805h31.007a9.827 9.827 0 0 0 6.94-2.51l31.3-30.564a13.9 13.9 0 0 0-19.487 0z"
                transform="translate(8.435 -59.4)"
              />
              <path
                id="Path_204"
                data-name="Path 204"
                className="cls-2"
                d="M0 105.429h66L24.363 82.1z"
                transform="translate(0 -48.583)"
              />
              <path
                id="Path_205"
                data-name="Path 205"
                className="cls-3"
                d="M72.756 96.172L31.265 72.4 16.5 86.722l41.638 23.329z"
                transform="translate(7.863 -53.205)"
              />
            </g>
          </g>
        </g>
        <g id="blue-heart" transform="translate(480.06 170.007)">
          <path
            id="Path_206"
            data-name="Path 206"
            className="cls-2"
            d="M126.306 23.182a23.193 23.193 0 0 0-40.162-15.8L84.077 9.45l-2.215-2.067A23.193 23.193 0 0 0 41.7 23.182a23.194 23.194 0 0 0 7.383 16.98l12.993 12.993L81.271 72.35l2.658 2.658 2.658-2.658 19.047-19.05 12.994-12.994a22.711 22.711 0 0 0 7.678-17.124z"
            transform="translate(-41.7)"
          />
          <path
            id="Path_207"
            data-name="Path 207"
            className="cls-3"
            d="M73.058 72.35L92.105 53.3 105.1 40.309a23.194 23.194 0 0 0 7.383-16.98A22.943 22.943 0 0 0 89.447 0a23.194 23.194 0 0 0-16.98 7.383L70.4 9.45v65.558z"
            transform="translate(-28.023)"
          />
        </g>
      </g>
      <g
        id="Group_1104"
        data-name="Group 1104"
        transform="translate(883.021 170.007)"
      >
        <g id="notes" data-name="Group 887">
          <path
            id="Rectangle_410"
            data-name="Rectangle 410"
            className="cls-1"
            transform="translate(10.163 8.22)"
            d="M0 0h98.794v136.757H0z"
          />
          <path
            id="Rectangle_411"
            data-name="Rectangle 411"
            className="cls-4"
            d="M0 0h98.794v136.458H0z"
          />
          <circle
            id="blue-dot"
            data-name="Ellipse 43"
            className="cls-2"
            cx={11.807}
            cy={11.807}
            r={11.807}
            transform="translate(54.254 90.125)"
          />
        </g>
        <g
          id="Group_890"
          data-name="Group 890"
          transform="translate(16.291 26.006)"
        >
          <g id="Group_889" data-name="Group 889">
            <g id="Group_888" data-name="Group 888">
                <path
                    id="Rectangle_414"
                    data-name="Rectangle 414"
                    className="cls-5 gray-text gray-text--1"
                    d="M0 0h61.728v4.334H0z"
                />
                <path
                    id="Rectangle_412"
                    data-name="Rectangle 412"
                    className="cls-5 gray-text gray-text--2"
                    transform="translate(0 13.601)"
                    d="M0 0h61.728v4.334H0z"
                />
                <path
                    id="Rectangle_413"
                    data-name="Rectangle 413"
                    className="cls-5 gray-text gray-text--3"
                    transform="translate(0 27.202)"
                    d="M0 0h61.728v4.334H0z"
                />
                <path
                    id="Rectangle_415"
                    data-name="Rectangle 415"
                    className="cls-5 gray-text gray-text--4"
                    transform="translate(0 40.803)"
                    d="M0 0h61.728v4.334H0z"
                />
              
                <path
                    id="Rectangle_416"
                    data-name="Rectangle 416"
                    className="cls-5 gray-text gray-text--5"
                    transform="translate(0 54.553)"
                    d="M0 0h61.728v4.334H0z"
                />
                <path
                    id="Rectangle_417"
                    data-name="Rectangle 417"
                    className="cls-5 gray-text gray-text--6"
                    transform="translate(0 68.005)"
                    d="M0 0h29.294v4.484H0z"
                />
            </g>
          </g>
        </g>
      </g>
      <g id="blue-monitor" data-name="Group 1585">
        <path
          id="Path_358"
          data-name="Path 358"
          className="cls-6"
          d="M180.8 120.533H11.895A11.929 11.929 0 0 1 0 108.638V11.895A11.929 11.929 0 0 1 11.895 0H180.4a11.929 11.929 0 0 1 11.9 11.895v96.347a11.7 11.7 0 0 1-11.5 12.291"
          transform="translate(624.094 170)"
        />
        <path
          id="Rectangle_465"
          data-name="Rectangle 465"
          className="cls-4"
          transform="translate(635.988 181.895)"
          d="M0 0h168.508v96.347H0z"
        />
        <path
          id="Rectangle_466"
          data-name="Rectangle 466"
          className="cls-6"
          transform="translate(672.466 302.428)"
          d="M0 0h96.347v11.895H0z"
        />
        <path
          id="Path_359"
          data-name="Path 359"
          className="cls-3"
          d="M75.17 30.4H27.195A11.929 11.929 0 0 1 15.3 42.295h71.765A11.682 11.682 0 0 1 75.17 30.4z"
          transform="translate(669.457 260.133)"
        />
        <path
          id="white-paper"
          data-name="Rectangle 467"
          transform="translate(660.174 194.186)"
          fill="#fff"
          d="M0 0h120.533v84.452H0z"
        />
        <path
          id="Line_43"
          data-name="Line 43"
          className="cls-8 orange-text"
          transform="translate(672.466 254.452)"
          d="M0 0h96.347"
        />
        <path
          id="Line_44"
          data-name="Line 44"
          className="cls-8 orange-text"
          transform="translate(672.466 266.347)"
          d="M0 0h47.975"
        />
        <path
          id="green-heart-bg-blue-circle"
          className="cls-3"
          d="M71.423 31.561A26.961 26.961 0 1 1 44.461 4.6a26.989 26.989 0 0 1 26.962 26.961"
          transform="translate(675.979 183.639)"
        />
        <path
          id="green-heart"
          d="M50.633 16.626a8.148 8.148 0 0 0-14.273-5.551l-.793.793-.793-.793A8.433 8.433 0 0 0 28.826 8.3a8.375 8.375 0 0 0-8.326 8.326 8.432 8.432 0 0 0 2.775 5.947l4.758 4.758 6.74 6.74.793.793.793-.793 6.74-6.74 4.758-4.758a7.75 7.75 0 0 0 2.775-5.947"
          transform="translate(684.874 194.609)"
          fill="#a4ce4d"
        />
      </g>
    </g>
  </svg>
)

const HomepageSVG = React.forwardRef((props, ref) => (
  <SvgComponent svgRef={ref} {...props} />
))

export default HomepageSVG
